import { useFrame } from './Canvas'

export const CanvasPrimitives = {
  ClearRect: () => (useFrame(({ ctx, width, height }) => ctx.clearRect(0, 0, width, height)), null),
  Save: () => (useFrame(({ ctx }) => ctx.save()), null),
  Restore: () => (useFrame(({ ctx }) => ctx.restore()), null),
}
